function renderLastSevenDaysBarChart(dates, viewCounts) {
    $('#last-seven-days-canvas').highcharts({
        chart: {
            type: 'column',
            backgroundColor: null,
            style: {
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                color: '#f1f1f9'
            }
        },
        title: {
            text: 'Views last seven days',
            style: {
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                color: '#474a4c',
                fontSize: '12px'
            }
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },
        xAxis: {
            categories: dates,
            type: 'datetime',
            labels: {
                style: {
                    fontSize: '6px'
                }
            }
        },
        yAxis: {
            title: {
                text: ''
            },
            labels: {
                style: {
                    fontSize: '8px'
                }
            },
            min: 0,
            gridLineColor: 'transparent'
        },
        plotOptions: {
            column: {
                pointPadding: 0,
                groupPadding: 0,
                borderWidth: 0,
                shadow: false,
                borderColor: 'transparent',
                states: {
                    hover: {
                        color: '#00263a'
                    }
                }
            }
        },
        tooltip: {
            backgroundColor: '#2F4050',
            borderColor: 'transparent',
            borderRadius: 4,
            borderWidth: 0,
            shadow: false,
            crosshairs: true,
            useHTML: true,
            headerFormat: '',
            pointFormat: '<span style="color:#f1f1f9">{point.y} views</span>'
        },
        series: [{
            name: '',
            data: viewCounts,
            colorByPoint: true,
            colors: ['#5f5f5f', '#696969', '#757575', '#7c7c7c', '#8f908f', '#a4a4a4', '#bebebe', '#d8d8d8'],
            dataLabels: {
                enabled: true,
                align: 'right',
                verticalAlign: 'bottom',
                y: 20,
                style: {
                    fontSize: '10px',
                    fontWeight: '200',
                    color: '#f1f1f9',
                    textShadow: false,
                    strokeWidth: 0
                }
            }
        }]
    });
}

function renderLastSevenDaysBarChartPrint(dates, viewCounts) {
    $('#last-seven-days-canvas').highcharts({
        chart: {
            type: 'column',
            backgroundColor: null,
            style: {
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                color: '#ffffff'
            }
        },
        title: {
            text: 'Views last seven days',
            style: {
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                fontSize: '13px'
            }
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },
        xAxis: {
            categories: dates,
            type: 'datetime',
            labels: {
                style: {
                    fontSize: '8px'
                }
            }
        },
        yAxis: {
            title: {
                text: ''
            },
            labels: {
                style: {
                    fontSize: '8px'
                }
            },
            min: 0
        },
        plotOptions: {
            column: {
                pointPadding: 0.025,
                groupPadding: 0.025,
                borderWidth: 1,
                shadow: false,
            }
        },
        tooltip: {
            enabled: false
        },
        series: [{
            name: '',
            animation: false,
            data: viewCounts,
            colorByPoint: true,
            colors: ['#0c6594'],
            borderRadiusTopLeft: 5,
            borderRadiusTopRight: 5,
            dataLabels: {
                enabled: true,
                style: {
                    fontSize: '10px',
                    fontWeight: '200',
                    textShadow: false,
                    strokeWidth: 0,
                    color: '#00263a'
                }
            }
        }]
    });
}

function renderLastThirtyDaysLineChart(dates, viewCounts, interactionCounts) {
    $(function() {
        $('#last-thirty-days-canvas').highcharts({
            chart: {
                type: 'areaspline',
                backgroundColor: null,
                style: {
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    color: '#474a4c'
                }
            },
            title: {
                text: 'Views & Interactions last thirty days',
                style: {
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    color: '#474a4c',
                    fontSize: '12px'
                }
            },
            credits: {
                enabled: false
            },
            xAxis: {
                categories: dates,
                labels: {
                    style: {
                        fontSize: '6px'
                    }
                }
            },
            yAxis: {
                title: {
                    text: ''
                },
                labels: {
                    style: {
                        fontSize: '8px'
                    }
                },
                gridLineColor: 'transparent'
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                floating: true,
                borderWidth: 0,
                itemStyle: {
                    fontSize: '8px',
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    color: '#474a4c'
                }
            },
            plotOptions: {
                areaspline: {
                    fillOpacity: 0,
                    lineWidth: 1,
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        radius: 2,
                        states: {
                            hover: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            tooltip: {
                backgroundColor: '#2F4050',
                borderColor: 'transparent',
                crosshairs: true,
                borderRadius: 4,
                borderWidth: 0,
                shadow: false,
                useHTML: true,
                shared: true,
                headerFormat: '<span style="color:#f1f1f9">{point.key}</span><br/>',
                pointFormat: '<span style="color:#f1f1f9">{point.y} {series.name}</span><br/>'
            },
            series: [{
                name: 'Views',
                data: viewCounts,
                color: '#7c7c7c'
            }, {
                name: 'Interactions',
                data: interactionCounts,
                color: '#a6192e'
            }]
        });
    });
}

function renderLastThirtyDaysLineChartPrint(dates, viewCounts, interactionCounts) {
    $(function() {
        $('#last-thirty-days-canvas').highcharts({
            chart: {
                backgroundColor: null,
                style: {
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
                }
            },
            title: {
                text: 'Views & Interactions last thirty days',
                style: {
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    fontSize: '13px'
                }
            },
            credits: {
                enabled: false
            },
            xAxis: {
                categories: dates,
                labels: {
                    style: {
                        fontSize: '6px'
                    }
                }
            },
            yAxis: {
                title: {
                    text: ''
                },
                labels: {
                    style: {
                        fontSize: '8px'
                    }
                }
            },
            legend: {
                verticalAlign: 'top',
                floating: true,
                borderWidth: 0,
                reversed: true,
                y: 8,
                itemStyle: {
                    fontSize: '10px',
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    fontWeight: '200'
                }
            },
            plotOptions: {
                line: {
                    fillOpacity: 0,
                    lineWidth: 1,
                    marker: {
                        enabled: false
                    }
                },
                column: {
                    borderWidth: 1,
                    shadow: false,
                    pointPadding: 0.1,
                    groupPadding: 0.05,
                    colors: ['#0c6594'],
                    marker: {
                        symbol: 'square'
                    }
                }
            },
            tooltip: {
                enabled: false
            },
            series: [{
                animation: false,
                type: 'column',
                name: 'Interactions',
                data: interactionCounts,
                borderRadiusTopLeft: 2,
                borderRadiusTopRight: 2,
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '6px',
                        fontWeight: '200',
                        textShadow: false,
                        strokeWidth: 0,
                        color: '#0c6594'
                    }
                }
            }, {
                animation: false,
                type: 'line',
                name: 'Views',
                data: viewCounts,
                color: '#a6192e',
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '6px',
                        fontWeight: '200',
                        color: '#a6192e',
                        textShadow: false,
                        strokeWidth: 0
                    }
                }
            }]
        });
    });
}

function renderMyBayleysLineChart(dates, enquiries, watchLists) {
    $(function() {
        $('#mybayleys-canvas').highcharts({
            chart: {
                type: 'line',
                backgroundColor: null,
                style: {
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    color: '#474a4c'
                }
            },
            title: {
                text: 'Enquiries & Watchlists last thirty days',
                style: {
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    color: '#474a4c',
                    fontSize: '12px'
                }
            },
            credits: {
                enabled: false
            },
            xAxis: {
                categories: dates,
                labels: {
                    style: {
                        fontSize: '6px'
                    }
                }
            },
            yAxis: {
                title: {
                    text: ''
                },
                labels: {
                    style: {
                        fontSize: '8px'
                    }
                },
                gridLineColor: 'transparent'
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                floating: true,
                borderWidth: 0,
                itemStyle: {
                    fontSize: '8px',
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    color: '#474a4c'
                }
            },
            plotOptions: {
                line: {
                    fillOpacity: 0,
                    lineWidth: 1,
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        radius: 2,
                        states: {
                            hover: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            tooltip: {
                backgroundColor: '#2F4050',
                borderColor: 'transparent',
                crosshairs: true,
                borderRadius: 4,
                borderWidth: 0,
                shadow: false,
                useHTML: true,
                shared: true,
                headerFormat: '<span style="color:#f1f1f9">{point.key}</span><br/>',
                pointFormat: '<span style="color:#f1f1f9">{point.y} {series.name}</span><br/>'
            },
            series: [{
                name: 'Enquiries',
                data: enquiries,
                color: '#7c7c7c'
            }, {
                name: 'WatchLists',
                data: watchLists,
                color: '#a6192e'
            }]
        });
    });
}

function renderMyBayleysLineChartPrint(dates, enquiries, watchLists, social, email, openHome, auction, tender, maps, download, print) {
    $(function() {
        $('#mybayleys-canvas').highcharts({
            chart: {
                type: 'column',
                backgroundColor: null,
                style: {
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
                }
            },
            title: {
                text: 'Events last thirty days',
                style: {
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    fontSize: '13px'
                }
            },
            credits: {
                enabled: false
            },
            xAxis: {
                categories: dates,
                labels: {
                    style: {
                        fontSize: '6px'
                    }
                }
            },
            yAxis: {
                title: {
                    text: ''
                },
                labels: {
                    style: {
                        fontSize: '8px'
                    }
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        fontSize: '6px',
                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                        fontWeight: '200',
                        color: '#00263a'
                    }
                }
            },
            legend: {
                verticalAlign: 'top',
                floating: true,
                borderWidth: 0,
                y: 8,
                itemStyle: {
                    fontSize: '10px',
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    fontWeight: '200'
                }
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    fillOpacity: 0,
                    lineWidth: 1,
                    borderWidth: 1,
                    shadow: false,
                    pointPadding: 0.1,
                    groupPadding: 0.05,
                    marker: {
                        enabled: false
                    }
                }
            },
            tooltip: {
                enabled: false
            },
            series: [{
                animation: false,
                type: 'column',
                name: 'Enquiries',
                data: enquiries,
                borderRadiusTopLeft: 2,
                borderRadiusTopRight: 2,
                color: '#0c6594',
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '6px',
                        fontWeight: '200',
                        color: '#0c6594',
                        textShadow: false,
                        strokeWidth: 0
                    }
                }
            }, {
                animation: false,
                type: 'column',
                name: 'WatchLists',
                data: watchLists,
                color: '#a6192e',
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '6px',
                        fontWeight: '200',
                        color: '#a6192e',
                        textShadow: false,
                        strokeWidth: 0
                    }
                }
            }]
        });
    });
}

function renderTreeMap(treemapData) {
    $('#countries-treemap-area').highcharts({
        chart: {
            backgroundColor: null,
            style: {
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                color: '#f1f1f9'
            }
        },
        title: {
            text: 'Views by country',
            style: {
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                color: '#474a4c',
                fontSize: '12px'
            }
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            treemap: {
                colorByPoint: true,
                borderColor: 'transparent',
                colors: ['#5f5f5f', '#696969', '#757575', '#7c7c7c', '#8f908f', '#a4a4a4', '#bebebe', '#d8d8d8'],
                states: {
                    hover: {
                        color: '#00263a'
                    }
                }
            }
        },
        tooltip: {
            backgroundColor: '#2F4050',
            borderColor: 'transparent',
            crosshairs: true,
            borderRadius: 4,
            borderWidth: 0,
            shadow: false,
            useHTML: true,
            headerFormat: '',
            pointFormat: '<span style="color:#f1f1f9">{point.value}% views from {point.name}</span>'
        },
        series: [{
            type: 'treemap',
            layoutAlgorithm: 'squarified',
            dataLabels: {
                style: {
                    fontSize: '9px',
                    fontWeight: '200',
                    color: '#f1f1f9',
                    textShadow: false
                },
                format: '{point.name}<br>{point.value}% '
            },
            data: treemapData
        }]
    });
}

function renderTreeMapPrint(treemapData) {
    $('#countries-treemap-area').highcharts({
        chart: {
            backgroundColor: null,
            style: {
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
            }
        },
        title: {
            text: 'Views by country',
            style: {
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                fontSize: '13px'
            }
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            treemap: {
                colorByPoint: true,
                borderColor: '#0c6594',
                colors: ['#0c6594']
            }
        },
        tooltip: {
            enabled: false
        },
        series: [{
            animation: false,
            type: 'treemap',
            layoutAlgorithm: 'squarified',
            dataLabels: {
                style: {
                    fontSize: '9px',
                    fontWeight: '200',
                    textShadow: false,
                    color: '#00263a'
                },
                format: '{point.value}%<br>{point.name}'
            },
            data: treemapData
        }]
    });
}